import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Clean tab routes: /app/<tab>. Legacy ?tab=<tab> links (notifications, old
 * bookmarks) are still read, and MainApp rewrites them to /app/<tab>.
 */
export function tabFromLocation(location) {
  const m = /^\/app\/([^/?#]+)/.exec(location.pathname);
  if (m) return decodeURIComponent(m[1]);
  return new URLSearchParams(location.search).get('tab');
}

export function tabPath(tab, search = '') {
  return `/app/${encodeURIComponent(tab)}${search}`;
}

/**
 * [tab, setTab] backed by the URL. `enabled=false` keeps it local-only
 * (used by read-only previews rendered inside another view).
 */
export function useRoutedTab(defaultTab, validTabs, localState, enabled = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const [local, setLocal] = localState;
  const fromUrl = enabled ? tabFromLocation(location) : null;
  const urlOk = fromUrl && (!validTabs || validTabs.includes(fromUrl));
  const tab = urlOk ? fromUrl : local;

  const setTab = useCallback(next => {
    setLocal(next);
    if (enabled) navigate(tabPath(next), { replace: true });
  }, [enabled, navigate, setLocal]);

  return [tab || defaultTab, setTab];
}
